import { TFunction } from 'i18next';

export const stepperConstant = {
  step1: 1,
  step2: 2,
  step3: 3,
  step4: 4,
  step5: 5,
  step6: 6,
  step7: 7,
  step8: 8,
  step9: 9,
  step10: 10,
};

export const PROVINCE = [
  {
    label: 'Alberta',
    value: 'Al',
  },
  {
    label: 'British Columbia',
    value: 'BC',
  },
  {
    label: 'Manitoba',
    value: 'MB',
  },
  {
    label: 'New Brunswick',
    value: 'NB',
  },
  {
    label: 'Newfoundland and Labrador',
    value: 'NL',
  },
  {
    label: 'Northwest Territories',
    value: 'NT',
  },
  {
    label: 'Nova Scotia',
    value: 'NS',
  },
  {
    label: 'Nunavut',
    value: 'NU',
  },
  {
    label: 'Ontario',
    value: 'ON',
  },
  {
    label: 'Prince Edward Island',
    value: 'PE',
  },
  {
    label: 'Quebec',
    value: 'QC',
  },
  {
    label: 'Saskatchewan',
    value: 'SK',
  },
  {
    label: 'Yukon',
    value: 'YT',
  },
];

export const TRADE_IN = (t: TFunction) => {
  return [
    {
      label: t('digitalRetailing.yesTradeIn'),
      value: 'Yes',
    },
    {
      label: t('digitalRetailing.noTradeIn'),
      value: 'No',
    },
  ];
};

export const MODULE_NAME = 'digital-retailing';

export const colorStyles = {
  listClass: 'tradein__cp-grid',
  itemClass: 'tradein__cp-grid__item',
  labelClass: 'cp-option',
  paletteClass: 'cp-option__palette',
  nameClass: 'cp-option__name',
};

export const PARENT_HEADER_STEPS = (t: TFunction) => {
  return [
    { step: 0, stepAllowed: [0, 1, 2, 3, 4, 5, 6, 7], name: t('digitalRetailing.step1') },
    { step: 1, stepAllowed: [1, 2, 3, 4, 5, 6, 7], name: t('digitalRetailing.step2') },
    { step: 2, stepAllowed: [6, 7], name: t('digitalRetailing.step4') },
    { step: 3, stepAllowed: [7], name: t('digitalRetailing.step6') },
    // { step: 4, stepAllowed: [7], name: t('digitalRetailing.step6') },
    // { step: 5, stepAllowed: [7], name: t('digitalRetailing.step6') },
  ];
};

export const PAYMENT_METHOD = (t: TFunction) => {
  return [
    { label: t('digitalRetailing.cash'), value: 'Cash' },
    { label: t('digitalRetailing.finance'), value: 'Finance' },
    // { label: t('digitalRetailing.lease'), value: 'Lease' },
  ];
};

export const ProjectionFields =
  'VIN,Trim,Odometer,SerialNumber,Status,VehicleType,Dealership,StockNumber,Make,Model,Year,Images,Retail,MSR';

export const TERM = [
  { label: '12', value: 12 },
  { label: '24', value: 24 },
  { label: '36', value: 36 },
  { label: '48', value: 48 },
  { label: '60', value: 60 },
  { label: '72', value: 72 },
  { label: '84', value: 84 },
  { label: '96', value: 96 },
];

export const TIME_OPTIONS = [
  '08:00',
  '08:30',
  '09:00',
  '09:30',
  '10:00',
  '10:30',
  '11:00',
  '11:30',
  '12:00',
  '12:30',
  '13:00',
  '13:30',
  '14:00',
  '14:30',
  '15:00',
  '15:30',
  '16:00',
  '16:30',
  '17:00',
  '17:30',
  '18:00',
  '18:30',
  '19:00',
  '19:30',
  '20:00',
];

export const RESIDENTIAL_OPTION = (t: TFunction) => {
  return [
    { label: t('digitalRetailing.own'), value: 'own' },
    { label: t('digitalRetailing.rent'), value: 'rent' },
    { label: t('digitalRetailing.parent'), value: 'parent' },
    { label: t('digitalRetailing.other'), value: 'other' },
  ];
};

export const INCOME_FREQUENCY_OPTION = (t: TFunction) => {
  return [
    { label: t('digitalRetailing.weekly'), value: 'W' },
    { label: t('digitalRetailing.biWeekly'), value: 'BiWK' },
    { label: t('digitalRetailing.monthly'), value: 'M' },
    { label: t('digitalRetailing.semiMonthly'), value: 'SmMO' },
    { label: t('digitalRetailing.annual'), value: 'A' },
  ];
};
